import fetch from '../api/fetch'

/**
 * 	Action to POST subjectivities
 *
 * 	@method POST
 */

export function extendSubjectivity(subjectivity: string) {
    return {
        type: 'EXTEND_SUBJECTIVITY',
        payload: fetch(`/policy/${subjectivity}/extend_subjectivity`, { method: 'POST' }),
    }
}

/**
 * 	Action to GET subjectivities
 *
 * 	@method GET
 */

export function getSubjectivity(subjectivity: string) {
    return {
        type: 'GET_SUBJECTIVITY',
        payload: fetch(`/policy/${subjectivity}/subjectivities`, { method: 'GET' }),
    }
}

/**
 * 	Action to DELETE subjectivities
 *
 * 	@method DELETE
 */

export function markSubjectivityAsCompleted(subjectivity: string) {
    return {
        type: 'MARK_SUBJECTIVITY_AS_COMPLETED',
        payload: fetch(`/policy/${subjectivity}/clear_subjectivity`, { method: 'DELETE' }),
    }
}

/**
 * 	Action to POST cancel policy
 *
 * 	@method POST
 */

export function cancelPolicy(policyId: string, reason: string) {
    return {
        type: 'CANCEL_POLICY',
        payload: fetch(`/policies/${policyId}/cancel`, { method: 'POST', body: { 'reason': reason } }),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/subjectivities.ts